var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAssignAdmin(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 57,
    height: 57,
    viewBox: "0 0 57 57",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Assign Admin"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group 4"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M22.1726 25.9022C21.9606 25.881 21.7061 25.881 21.4729 25.9022C16.427 25.7326 12.4199 21.5983 12.4199 16.51C12.4199 11.3156 16.6178 7.09656 21.8334 7.09656C27.0277 7.09656 31.2468 11.3156 31.2468 16.51C31.2256 21.5983 27.2185 25.7326 22.1726 25.9022Z",
    stroke: "#292D32",
    strokeWidth: 2.62553,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M37.5439 11.3364C41.657 11.3364 44.9644 14.665 44.9644 18.7569C44.9644 22.764 41.7842 26.029 37.8195 26.1774C37.6499 26.1562 37.4591 26.1562 37.2683 26.1774",
    stroke: "#292D32",
    strokeWidth: 2.62553,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M11.5712 33.725C6.44046 37.1596 6.44046 42.7568 11.5712 46.1702C17.4016 50.0712 26.9634 50.0712 32.7938 46.1702C37.9246 42.7356 37.9246 37.1384 32.7938 33.725C26.9846 29.8451 17.4228 29.8451 11.5712 33.725Z",
    stroke: "#292D32",
    strokeWidth: 2.62553,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M41.6353 45.2588C43.1618 44.9408 44.6034 44.3259 45.7907 43.4143C49.0981 40.9337 49.0981 36.8418 45.7907 34.3613C44.6247 33.4708 43.2042 32.8772 41.6989 32.538",
    stroke: "#292D32",
    strokeWidth: 2.62553,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAssignAdmin);
export default __webpack_public_path__ + "static/media/assignAdmin.fbd703f61d000cddfd4ecfddfbccc71d.svg";
export { ForwardRef as ReactComponent };